import Vue from 'vue/dist/vue.esm';
import InviteForm from './form.vue';

export default () => {
    Vue.component('InviteForm', InviteForm);
};